var map = {
	"./de/mecha-active-btn.png": "y462",
	"./en/mecha-active-btn.png": "yD3A",
	"./es/mecha-active-btn.png": "bSGs",
	"./fr/mecha-active-btn.png": "NJcr",
	"./ja/mecha-active-btn.png": "6ep3",
	"./ko/mecha-active-btn.png": "sqpL",
	"./pt/mecha-active-btn.png": "7QlI",
	"./ru/mecha-active-btn.png": "x/xP",
	"./tc/mecha-active-btn.png": "bAPT",
	"./th/mecha-active-btn.png": "AJXm"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "D5tp";